import { supabase, q } from './supabase';

/**
 * Makes sure a `profiles` row exists for the signed-in user.
 *
 * `groups.created_by` and `group_members.profile_id` both have foreign keys
 * pointing at `profiles`, so without this row every "create group" fails with a
 * confusing FK violation. A database trigger on auth.users can do this too (see
 * sql/02-profile-trigger.sql), but doing it here as well means the app works
 * even if that trigger was never installed.
 */
export async function ensureProfile(user) {
  if (!user) return null;
  const meta = user.user_metadata || {};
  const fallbackName =
    meta.display_name || meta.full_name || meta.name || (user.email ? user.email.split('@')[0] : 'Player');

  const existing = await q(
    supabase.from('profiles').select('id, display_name').eq('id', user.id).maybeSingle(),
    'Loading your profile'
  );

  if (existing) return existing;

  return q(
    supabase.from('profiles').insert({ id: user.id, display_name: fallbackName }).select().single(),
    'Creating your profile'
  );
}
